
import { FaEye, FaPencilAlt, FaTicketAlt, FaChartLine, FaUsers, FaImages } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function EventSidebarLinks({ event }) {
  return (
    <div className="event-left-sidebar d-none d-xl-flex">
      <div className="event-left-sidebar-links">
        <a
          href={`${process.env.REACT_APP_API_BASE_URL}/product/${event?.post_name}`}
          className="btn text-silver"
        >
          <FaEye/>
        </a>
        {/* Disable Editing Past/Ended Events */}
        {(event.post_status === 'draft' || event.is_upcoming) && (
          <Link
            to={'/events/' + event?.ID}
            className="btn text-silver"
          >
            <FaPencilAlt/>
          </Link>
        )}
        <Link
          to={'/events/' + event?.ID + '/tickets'}
          className="btn text-silver"
        >
          <FaTicketAlt/>
        </Link>
        <Link
          to={'/events/' + event?.ID + '/stats'}
          className="btn text-silver"
        >
          <FaChartLine/>
        </Link>
        <Link
          to={'/events/' + event?.ID + '/team'}
          className="btn text-silver"
        >
          <FaUsers/>
        </Link>
        <Link
          to={'/events/' + event?.ID + '/gallery'}
          className="btn text-silver"
        >
          <FaImages/>
        </Link>
      </div>
    </div>
  );
}
